import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getAllReconcileData } from "src/thunks/reports";
import { Loader } from "src/components/loader";
import { GetError } from "src/constant";
import { Monthly } from "./reportType/monthly";
import moment from "moment";
import _ from "lodash";

export const ReportList = () => {
    /** redux store useDispatch & useSelector ------------------------------ **/
    const dispatch = useDispatch();
    const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
    const { reconcileData, reconcileDataLoading } = useSelector((state) => state.reports);
    const { filterAllData } = useSelector((state) => state.goodsin);

    /** Variable Declarations ----------------------------------------------------- **/
    const filterData = filterAllData["Reconsilition"]

    /** hooks useEffect----------------------------------------------------- **/
    useEffect(() => {
        getAllReportsDataFunc()
    }, [])

    const lookupValues = useSelector((state) => state.lookup);
    let filterDataLookup = _.find(lookupValues?.data, (d) => d?.typeName === "ItemStorageType")

    /** Function to retrieve all reports data ------------------------ **/
    const getAllReportsDataFunc = async () => {
        try {
            let data = {
                fromDate: filterData?.fromDate ? moment(filterData?.fromDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                DepotIds: [filterData?.depotId?.id || 0],
                ClientIds: [filterData?.clientId?.id || 0],
                ProjectIds: [filterData?.projectId?.id || 0],
                spaceType: [(filterData?.spaceType?.value) || (filterDataLookup ? filterDataLookup?.id : 21)],
            };
            await dispatch(getAllReconcileData({ ...data }))
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
    }

    if (reconcileDataLoading) {
        return <Loader />;
    }
    /** If data not found in report shown no data found message ------------------- **/
    if (reconcileData?.length === 0) {
        return <div style={{ display: "flex", width: "100%", justifyContent: "center", height: 500, alignItems: "center" }}>
            No Data found
        </div>
    }
    else
        return (
            <>
                <div className={`summaryReportMain ${isDropdownOpenFlagValue == true ? "add-overlay-for-depot-dropdown" : ""}`} >
                    <Monthly data={reconcileData} />
                </div>

            </>
        )
};
